module.exports = __webpack_public_path__ + "assets/img/186201.cb778d2c.png";